/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceObjectMaintenanceStatusCreateV1Dto } from './ServiceObjectMaintenanceStatusCreateV1Dto';
import type { ServiceObjectPartnerCreateV1Dto } from './ServiceObjectPartnerCreateV1Dto';
export type ServiceObjectCreateV1Dto = {
  /**
   * ID of the area associated with the service object
   */
  areaId: string;
  /**
   * Comments related to the service object
   */
  comments?: string;
  /**
   * Construction year of the service object
   */
  constructionYear?: number;
  /**
   * ID of the customer associated with the service object
   */
  customerId: string;
  /**
   * Inventory number of the service object
   */
  inventoryNumber?: string;
  /**
   * Maintenance status entries associated with the service object
   */
  maintenanceStatuses: Array<ServiceObjectMaintenanceStatusCreateV1Dto>;
  /**
   * Manufacturer of the service object
   */
  manufacturer?: string;
  /**
   * Model of the service object
   */
  model?: string;
  /**
   * Name of the service object
   */
  name: string;
  /**
   * ID of the object type associated with the service object
   */
  objectTypeId: string;
  /**
   * Partners associated with the service object along with their roles
   */
  partners?: Array<ServiceObjectPartnerCreateV1Dto> | null;
  /**
   * Responsibility of the service object
   */
  responsibleRole: ServiceObjectCreateV1Dto.responsibleRole;
  /**
   * Serial number of the service object
   */
  serialNumber?: string;
};
export namespace ServiceObjectCreateV1Dto {
  /**
   * Responsibility of the service object
   */
  export enum responsibleRole {
    CUSTOMER = 'Customer',
    LANDLORD = 'Landlord',
    MAINTENANCE = 'Maintenance',
    PARTNER = 'Partner',
  }
}
